export default "__VITE_PUBLIC_ASSET__b6cce993__"